import { get, merge, cloneDeep } from 'lodash-es'
import { TYPE as B_ATTRS, ARTICLE_TYPE } from '@/js/helper/bike-attributes'
import { TYPE as F_ATTRS, CONSTANTS as F_CONSTANTS } from '@/js/helper/filter-constants.js'
import { DP_ROLE } from '@/js/helper/dp-usermanagement-constants'
import AIMEOS from '@/js/helper/aimeos-constants.js'
import { CONSTANTS as STOCK } from '@/js/helper/stock-constants.js'

const ATR = {
  ...B_ATTRS,
  ...F_ATTRS,
  SUMMARY: 'Summary',
  BRAND_CATALOG: 'BrandCatalog',
}

const ATR_CODE = {
  PRODUCT_VARIANTS_CURRENT: 'ProductVariantsCurrent',
  PRODUCT_VARIANTS_OUTLET: 'ProductVariantsOutlet',
  ARCHIVE_ITEM: 'ArchiveItem',
  BIKE: 'bike',
  SPAREPART: 'part',
  ACCESSORY: 'accessory',
  PARTS: 'parts',
  STOCK_SOLD_OUT: 'StockSoldOut',
  HIDDEN_MIN_VALUE_OFF: 'hiddenMinValue_off',
  RALEIGH: 'Raleigh',
  FOCUS: 'FO',
  KALKHOFF: 'KH',
  URBANARROW: 'UA',
  UA_FAMILY_SEGMENTS: 'uaFamilySegments',
  UA_CARGO_BIKE: 'uaCargoBike',
  UA_WALK_FAMILY_BIKE: 'uaWalkFamilyBike',
  UA_WALK_CARGO_BIKE: 'uaWalkCargoBike',
  GZ: 'GZ',
  UO: 'UO',
  UNIVEGA: 'Univega',
  DC_CERVELO: 'DCCervelo',
  DCSANTACRUZ: 'DCSANTACRUZ',
  DCJULIANA: 'DCJULIANA',
  SERVICE: 'Service',
  SHOP: 'shop',
  DEALERBOOK: 'dealerbook',
  HasOutletSalesPrice: 'HasOutletSalesPrice',
}

const categoryTitleBrandMap = {
  cerveloCustomerService: 'DCCervelo',
  cervéloDp2020: 'DCCervelo',
  derbyCycleCustomerService: 'focus,kalkhoff',
  dp2020Cervélo: 'DCCervelo',
  dp2020CervéloOutlet: 'DCCervelo',
  dp2020Focus: 'focus',
  dp2020FocusOutlet: 'focus',
  dp2020Juliana: 'DCJULIANA',
  dp2020JulianaOutlet: 'DCJULIANA',
  dp2020Kalkhoff: 'kalkhoff',
  dp2020KalkhoffOutlet: 'kalkhoff',
  dp2020Raleigh: 'raleigh',
  dp2020RaleighOutlet: 'raleigh',
  dp2020SantaCruz: 'DCSANTACRUZ',
  dp2020SantaCruzOutlet: 'DCSANTACRUZ',
  dp2020Univega: 'univega',
  dp2020UnivegaOutlet: 'univega',
  focusDp2020: 'focus',
  focusOutletDp2020: 'focus',
  julianaDp2020: 'DCJULIANA',
  kalkhoffDp2020: 'kalkhoff',
  kalkhoffOutletDp2020: 'kalkhoff',
  raleighDp2020: 'raleigh',
  raleighOutletDp2020: 'raleigh',
  raleighUnivegaCustomerService: 'raleigh,univega',
  santaCruzCustomerService: 'DCSANTACRUZ,DCJULIANA',
  santaCruzDp2020: 'DCSANTACRUZ',
  univegaDp2020: 'univega',
}

export const scopes = {
  // F_CONSTANTS.SCOPE.CURRENT,
  // F_CONSTANTS.SCOPE.OUTLET,
  // F_CONSTANTS.SCOPE.SERVICE,
  // F_CONSTANTS.SCOPE.ALL,
  [F_CONSTANTS.SCOPE.BIKES]: DP_ROLE.SHOP_BIKES_R.p,
  [F_CONSTANTS.SCOPE.BIKES_ITEMS]: DP_ROLE.SHOP_BIKES_R.p,
  [F_CONSTANTS.SCOPE.SERVICE]: DP_ROLE.SHOP_PARTS_R.p,
  [F_CONSTANTS.SCOPE.PART_SALE]: DP_ROLE.SHOP_PARTS_R.p,
  [F_CONSTANTS.SCOPE.ACCESSORIES]: DP_ROLE.SHOP_ACCESSORIES_R.p,
  [F_CONSTANTS.SCOPE.ARCHIVE]: DP_ROLE.SHOP_ARCHIVE_R.p,
}

export const articleTypesToPermissions = {
  [ARTICLE_TYPE.BIKE]: DP_ROLE.SHOP_BIKES_R.p,
  [ARTICLE_TYPE.SPAREPART]: DP_ROLE.SHOP_PARTS_R.p,
  [ARTICLE_TYPE.ACCESSORY]: DP_ROLE.SHOP_BIKES_R.p,
}

// TODO: Remove when all filter settings are changed from fetching them by translations
export const getTranslationData = () => {
  return merge({}, filter, {
    config: {
      order: filter.config.order.join(','),
      scope: {
        ALL: {
          order: filter.config.scope.ALL.order.join(','),
          openOnStart: filter.config.scope.ALL.openOnStart.join(','),
          summaryOrder: filter.config.scope.ALL.summaryOrder.join(','),
        },
        BIKES: {
          order: filter.config.scope.BIKES.order.join(','),
          openOnStart: filter.config.scope.BIKES.openOnStart.join(','),
          summaryOrder: filter.config.scope.BIKES.summaryOrder.join(','),
        },
        // CURRENT: {
        //   order: filter.config.scope.CURRENT.order.join(','),
        //   openOnStart: filter.config.scope.CURRENT.openOnStart.join(','),
        //   summaryOrder: filter.config.scope.CURRENT.summaryOrder.join(','),
        // },
        // OUTLET: {
        //   order: filter.config.scope.OUTLET.order.join(','),
        //   openOnStart: filter.config.scope.OUTLET.openOnStart.join(','),
        //   summaryOrder: filter.config.scope.OUTLET.summaryOrder.join(','),
        // },
        SERVICE: {
          order: filter.config.scope.SERVICE.order.join(','),
          openOnStart: filter.config.scope.SERVICE.openOnStart.join(','),
          summaryOrder: filter.config.scope.SERVICE.summaryOrder.join(','),
        },
        PART_SALE: {
          order: filter.config.scope.SERVICE.order.join(','),
          openOnStart: filter.config.scope.SERVICE.openOnStart.join(','),
          summaryOrder: filter.config.scope.SERVICE.summaryOrder.join(','),
        },
        ARCHIVE: {
          order: filter.config.scope.ARCHIVE.order.join(','),
          openOnStart: filter.config.scope.ARCHIVE.openOnStart.join(','),
          summaryOrder: filter.config.scope.ARCHIVE.summaryOrder.join(','),
        },
      },
    },
  })
}

export const getActiveFiltersForScope = scope => {
  // console.log('getActiveFiltersForScope', scope, get(filter.config.scope, [scope, 'items'], {}))
  return Object.entries(get(filter.config.scope, [scope, 'items'], {})).reduce(
    (result, [type, attrs]) => {
      const activeAttrs = Object.entries(attrs)
        .filter(([, setting]) => get(setting, 'active') === '1')
        .map(([code]) => [type, code])
      if (!activeAttrs.length) {
        return result
      }
      result.push([type, activeAttrs])
      return result
    },
    [],
  )
}

export const maxResultAge = 15

const BIKES = {
  productType: AIMEOS.PRODUCTS.TYPE.SELECT,
  order: [
    ATR.ARTICLE_TYPE,
    ATR.PRODUCT_VARIANTS,
    // ATR.ZZCA_CLIENT,
    ATR.ITEM_BRAND,
    // ATR.CATEGORY,
    ATR.PIM_CATEGORY,
    ATR.PRODUCT_MAIN_CATEGORY,
    ATR.PRODUCT_BIDEX_COMMODITY_GROUP,
    ATR.STOCK,
    ATR.ITEM_FRAME_SIZE,
    // ATR.ITEM_FRAME_TYPE,
    ATR.ITEM_GENDER_FRAME,
    // ATR.EBIKE_SYSTEM_AND_MODEL,
    ATR.EBIKE_SYSTEM_BRAND,
    ATR.ITEM_BATTERY_WATT_HOURS,
    ATR.ITEM_COASTER_BRAKE,
    ATR.PRODUCT_GEAR_TYPE,
    ATR.ITEM_WHEEL_SIZE_INCH,
    ATR.ITEM_FILTER_COLOR,
    ATR.SEARCH_PRICE,
  ],
  openOnStart: [
    ATR.ITEM_BRAND,
    // ATR.CATEGORY,
    ATR.PIM_CATEGORY,
    ATR.BRAND_CATALOG,
    // ATR.ZZCA_CLIENT,
    ATR.PRODUCT_VARIANTS,
  ],
  summaryOrder: [
    ATR.SEARCH_TEXT,
    ATR.SEARCH_PRICE,
    ATR.PRODUCT_VARIANTS,
    // ATR.ZZCA_CLIENT,
    ATR.ITEM_BRAND,
    ATR.CATEGORIES,
    ATR.CATEGORY,
    ATR.PIM_CATEGORY,
    ATR.PRODUCT_MAIN_CATEGORY,
    ATR.PRODUCT_BIDEX_COMMODITY_GROUP,
    ATR.STOCK,
    ATR.ITEM_FRAME_SIZE,
    ATR.ITEM_GENDER_FRAME,
    // ATR.ITEM_FRAME_TYPE,
    // ATR.EBIKE_SYSTEM_AND_MODEL,
    ATR.EBIKE_SYSTEM_BRAND,
    ATR.EBIKE_ENGINE_MODEL,
    ATR.ITEM_BATTERY_WATT_HOURS,
    ATR.ITEM_COASTER_BRAKE,
    ATR.PRODUCT_GEAR_TYPE,
    ATR.ITEM_WHEEL_SIZE_INCH,
    ATR.ITEM_FILTER_COLOR,
  ],
  summaryHideAndKeep: [
    ATR.SEARCH_INCLUDED,
    ATR.SEARCH_PAGE,
    ATR.SEARCH_OFFSET,
    ATR.SEARCH_LIMIT,
    ATR.ARTICLE_TYPE,
  ],
  summaryHideWhenOnlyOneOption: [ATR.PRODUCT_VARIANTS],
  items: {
    [ATR.PRODUCT_VARIANTS]: {
      [ATR_CODE.PRODUCT_VARIANTS_CURRENT]: { ignore: '1' },
      // [ATR_CODE.PRODUCT_VARIANTS_OUTLET]: { ignore: '1' },
      [ATR_CODE.ARCHIVE_ITEM]: { ignore: '1' },
    },
    [ATR.ARTICLE_TYPE]: {
      [ATR_CODE.BIKE]: { active: '1' },
      [ATR_CODE.ACCESSORY]: { ignore: '1' },
      [ATR_CODE.SPAREPART]: { ignore: '1' },
    },
    [ATR.STOCK]: {
      [ATR_CODE.STOCK_SOLD_OUT]: { ignore: '1' },
    },
    [ATR.SEARCH_PRICE]: {
      [ATR_CODE.HIDDEN_MIN_VALUE_OFF]: '0.01',
    },
    // [ATR.ITEM_TYPE]: {
    //   [ATR_CODE.SHOP]: { active: '1' },
    // },
  },
}

const SERVICE = {
  order: [ATR.ARTICLE_TYPE, ATR.ZZCA_CLIENT, ATR.PART_BRAND, ATR.CATEGORY],
  openOnStart: [ATR.SUMMARY, ATR.PART_BRAND, ATR.BRAND_CATALOG, ATR.CATEGORY, ATR.ZZCA_CLIENT],
  summaryOrder: [ATR.SEARCH_TEXT, ATR.ZZCA_CLIENT, ATR.PART_BRAND, ATR.CATEGORY],
  summaryHideAndKeep: [
    ATR.SEARCH_INCLUDED,
    ATR.SEARCH_PAGE,
    ATR.SEARCH_OFFSET,
    ATR.SEARCH_LIMIT,
    ATR.ARTICLE_TYPE,
  ],
  summaryHideWhenOnlyOneOption: [ATR.PRODUCT_VARIANTS],
  items: {
    // [ATR.ITEM_BRAND]: {
    //   [ATR_CODE.RALEIGH]: { ignore: '1', sort: 3 },
    //   [ATR_CODE.FOCUS]: { ignore: '1', sort: 2 },
    //   [ATR_CODE.KALKHOFF]: { ignore: '1', sort: 1 },
    //   [ATR_CODE.URBANARROW]: { ignore: '1', sort: 3 },
    //   [ATR_CODE.UNIVEGA]: { ignore: '1', sort: 6 },
    //   [ATR_CODE.DC_CERVELO]: { ignore: '1', sort: 4 },
    //   [ATR_CODE.DCSANTACRUZ]: { ignore: '1', sort: 5 },
    //   [ATR_CODE.DCJULIANA]: { ignore: '1', sort: 7 },
    // },
    [ATR.PART_BRAND]: {
      [ATR_CODE.FOCUS]: { sort: 2 },
      [ATR_CODE.KALKHOFF]: { sort: 1 },
      [ATR_CODE.URBANARROW]: { sort: 3 },
      [ATR_CODE.GZ]: { ignore: '1', sort: 99 },
      [ATR_CODE.UO]: { ignore: '1', sort: 99 },
    },
    [ATR.ARTICLE_TYPE]: {
      [ATR_CODE.BIKE]: { ignore: '1' },
      [ATR_CODE.ACCESSORY]: { ignore: '1' },
      [ATR_CODE.SPAREPART]: { active: '1' },
    },
    [ATR.STOCK]: {
      [ATR_CODE.STOCK_SOLD_OUT]: { ignore: '1' },
    },
  },
}
const BIKES_ITEMS = cloneDeep(BIKES)
BIKES_ITEMS.productType = AIMEOS.PRODUCTS.TYPE.DEFAULT
BIKES_ITEMS.order = [ATR.SEARCH_TEXT, ...BIKES_ITEMS.order.filter(i => i !== ATR.ITEM_BRAND)]
BIKES_ITEMS.openOnStart = [ATR.SEARCH_TEXT, ATR.SEARCH_PRICE, ...BIKES_ITEMS.openOnStart]

BIKES_ITEMS.items[ATR.STOCK] = {
  [STOCK.ATTRIBUTES.STOCK_AVAILABLE]: { active: '1', noRemove: '1' },
  [STOCK.ATTRIBUTES.STOCK_SOON]: { active: '1', noRemove: '1' },
  [STOCK.ATTRIBUTES.STOCK_LATER]: { active: '1', noRemove: '1' },
  [STOCK.ATTRIBUTES.STOCK_SOLD_OUT]: { ignore: '1' },
}
BIKES_ITEMS.items[ATR.SEARCH_PRICE] = {
  [ATR.SEARCH_PRICE]: { noRemove: '1' },
}
BIKES_ITEMS.items[ATR.ITEM_BRAND] = {
  [ATR_CODE.FOCUS]: { noRemove: '1' },
  [ATR_CODE.KALKHOFF]: { noRemove: '1' },
  [ATR_CODE.URBANARROW]: { noRemove: '1' },
}
console.log('🚀 ~ BIKES_ITEMS:', BIKES_ITEMS)

const PART_SALE = cloneDeep(SERVICE)
PART_SALE.productType = AIMEOS.PRODUCTS.TYPE.DEFAULT
PART_SALE.items[ATR.HAS_OUTLET_SALES_PRICE] = {
  [ATR_CODE.HasOutletSalesPrice]: { active: '1' },
}
PART_SALE.summaryHideAndKeep.push(ATR.HAS_OUTLET_SALES_PRICE)
PART_SALE.order.push(ATR.HAS_OUTLET_SALES_PRICE)

export const filter = {
  config: {
    scopes,
    categoryTitleBrandMap,
    order: [
      ATR.ITEM_BRAND,
      ATR.PRODUCT_MAIN_CATEGORY,
      ATR.PRODUCT_BIDEX_COMMODITY_GROUP,
      ATR.ITEM_FRAME_SIZE,
      ATR.ITEM_GENDER_FRAME,
      ATR.ITEM_FILTER_COLOR,
    ],
    scope: {
      ALL: {
        order: [
          ATR.ARTICLE_TYPE,
          ATR.ZZCA_CLIENT,

          ATR.ITEM_SUPPLIER,
          ATR.ITEM_BRAND,
          ATR.CATEGORIES,
          ATR.PRODUCT_MAIN_CATEGORY,
          ATR.PRODUCT_SEASON,
          ATR.PRODUCT_BIDEX_COMMODITY_GROUP,
          ATR.STOCK,
          ATR.ITEM_FRAME_SIZE,
          ATR.ITEM_GENDER_FRAME,
          // ATR.EBIKE_SYSTEM_AND_MODEL,
          ATR.EBIKE_SYSTEM_BRAND,
          ATR.ITEM_BATTERY_WATT_HOURS,
          ATR.ITEM_COASTER_BRAKE,
          ATR.PRODUCT_GEAR_TYPE,
          ATR.ITEM_WHEEL_SIZE_INCH,
          ATR.ITEM_FILTER_COLOR,
          ATR.SEARCH_PRICE,
        ],
        openOnStart: [ATR.SUMMARY, ATR.ITEM_BRAND, ATR.BRAND_CATALOG, ATR.ZZCA_CLIENT],
        summaryOrder: [
          ATR.SEARCH_TEXT,
          ATR.SEARCH_PRICE,

          ATR.ZZCA_CLIENT,
          ATR.ITEM_SUPPLIER,
          ATR.ITEM_BRAND,
          ATR.CATEGORIES,
          ATR.CATEGORY,
          ATR.PRODUCT_MAIN_CATEGORY,
          ATR.PRODUCT_SEASON,
          ATR.PRODUCT_BIDEX_COMMODITY_GROUP,
          ATR.STOCK,
          ATR.ITEM_FRAME_SIZE,
          ATR.ITEM_GENDER_FRAME,
          // ATR.EBIKE_SYSTEM_AND_MODEL,
          ATR.EBIKE_SYSTEM_BRAND,
          ATR.EBIKE_ENGINE_MODEL,
          ATR.ITEM_BATTERY_WATT_HOURS,
          ATR.ITEM_COASTER_BRAKE,
          ATR.PRODUCT_GEAR_TYPE,
          ATR.ITEM_WHEEL_SIZE_INCH,
          ATR.ITEM_FILTER_COLOR,
          ATR.SEARCH_PRICE,
        ],
        summaryHideAndKeep: [
          ATR.SEARCH_INCLUDED,
          ATR.SEARCH_PAGE,
          ATR.SEARCH_OFFSET,
          ATR.SEARCH_LIMIT,
        ],
      },
      BIKES,
      BIKES_ITEMS,
      SERVICE,
      PART_SALE,
      // CURRENT: {
      //   order: [
      //     ATR.ARTICLE_TYPE,
      //
      //     ATR.ITEM_BRAND,
      //     ATR.CATEGORIES,
      //     ATR.BRAND_CATALOG,
      //     ATR.PRODUCT_MAIN_CATEGORY,
      //     ATR.PRODUCT_BIDEX_COMMODITY_GROUP,
      //     ATR.STOCK,
      //     ATR.ITEM_FRAME_SIZE,
      //     ATR.ITEM_GENDER_FRAME,
      //     ATR.EBIKE_SYSTEM_AND_MODEL,
      //     ATR.ITEM_BATTERY_WATT_HOURS,
      //     ATR.ITEM_COASTER_BRAKE,
      //     ATR.PRODUCT_GEAR_TYPE,
      //     ATR.ITEM_WHEEL_SIZE_INCH,
      //     ATR.ITEM_FILTER_COLOR,
      //     ATR.SEARCH_PRICE,
      //   ],
      //   openOnStart: [ATR.SUMMARY, ATR.ITEM_BRAND, ATR.BRAND_CATALOG, ATR.ZZCA_CLIENT],
      //   summaryOrder: [
      //     ATR.SEARCH_TEXT,
      //     ATR.SEARCH_PRICE,
      //
      //     ATR.ITEM_BRAND,
      //     ATR.CATEGORIES,
      //     ATR.PRODUCT_MAIN_CATEGORY,
      //     ATR.PRODUCT_BIDEX_COMMODITY_GROUP,
      //     ATR.STOCK,
      //     ATR.ITEM_FRAME_SIZE,
      //     ATR.ITEM_GENDER_FRAME,
      //     ATR.EBIKE_SYSTEM_AND_MODEL,
      //     ATR.EBIKE_SYSTEM_BRAND,
      //     ATR.EBIKE_ENGINE_MODEL,
      //     ATR.ITEM_BATTERY_WATT_HOURS,
      //     ATR.ITEM_COASTER_BRAKE,
      //     ATR.PRODUCT_GEAR_TYPE,
      //     ATR.ITEM_WHEEL_SIZE_INCH,
      //     ATR.ITEM_FILTER_COLOR,
      //     ATR.SEARCH_PRICE,
      //   ],
      //   summaryHideAndKeep: [
      //
      //     ATR.SEARCH_INCLUDED,
      //     ATR.SEARCH_PAGE,
      //     ATR.SEARCH_OFFSET,
      //     ATR.SEARCH_LIMIT,
      //     ATR.ARTICLE_TYPE,
      //   ],
      //   items: {
      //     [ATR.PRODUCT_VARIANTS]: {
      //       [ATR_CODE.PRODUCT_VARIANTS_CURRENT]: { active: '1' },
      //       [ATR_CODE.PRODUCT_VARIANTS_OUTLET]: { ignore: '1' },
      //       [ATR_CODE.ARCHIVE_ITEM]: { ignore: '1' },
      //     },
      //     [ATR.ARTICLE_TYPE]: {
      //       [ATR_CODE.BIKE]: { active: '1' },
      //       [ATR_CODE.SPAREPART]: { ignore: '1' },
      //     },
      //     [ATR.STOCK]: {
      //       [ATR_CODE.STOCK_SOLD_OUT]: { ignore: '1' },
      //     },
      //     [ATR.SEARCH_PRICE]: {
      //       [ATR_CODE.HIDDEN_MIN_VALUE_OFF]: '0.01',
      //     },
      //   },
      // },
      // OUTLET: {
      //   order: [
      //     ATR.ARTICLE_TYPE,
      //
      //     ATR.ITEM_BRAND,
      //     ATR.CATEGORIES,
      //     ATR.PRODUCT_MAIN_CATEGORY,
      //     ATR.PRODUCT_BIDEX_COMMODITY_GROUP,
      //     ATR.STOCK,
      //     ATR.ITEM_FRAME_SIZE,
      //     ATR.ITEM_GENDER_FRAME,
      //     ATR.EBIKE_SYSTEM_AND_MODEL,
      //     ATR.ITEM_BATTERY_WATT_HOURS,
      //     ATR.ITEM_COASTER_BRAKE,
      //     ATR.PRODUCT_GEAR_TYPE,
      //     ATR.ITEM_WHEEL_SIZE_INCH,
      //     ATR.ITEM_FILTER_COLOR,
      //     ATR.SEARCH_PRICE,
      //   ],
      //   openOnStart: [ATR.SUMMARY, ATR.ITEM_BRAND, ATR.BRAND_CATALOG, ATR.ZZCA_CLIENT],
      //   summaryOrder: [
      //     ATR.SEARCH_TEXT,
      //     ATR.SEARCH_PRICE,
      //
      //     ATR.ITEM_BRAND,
      //     ATR.CATEGORIES,
      //     ATR.PRODUCT_MAIN_CATEGORY,
      //     ATR.PRODUCT_BIDEX_COMMODITY_GROUP,
      //     ATR.STOCK,
      //     ATR.ITEM_FRAME_SIZE,
      //     ATR.ITEM_GENDER_FRAME,
      //     ATR.EBIKE_SYSTEM_AND_MODEL,
      //     ATR.EBIKE_SYSTEM_BRAND,
      //     ATR.EBIKE_ENGINE_MODEL,
      //     ATR.ITEM_BATTERY_WATT_HOURS,
      //     ATR.ITEM_COASTER_BRAKE,
      //     ATR.PRODUCT_GEAR_TYPE,
      //     ATR.ITEM_WHEEL_SIZE_INCH,
      //     ATR.ITEM_FILTER_COLOR,
      //     ATR.SEARCH_PRICE,
      //   ],
      //   summaryHideAndKeep: [
      //
      //     ATR.SEARCH_INCLUDED,
      //     ATR.SEARCH_PAGE,
      //     ATR.SEARCH_OFFSET,
      //     ATR.SEARCH_LIMIT,
      //     ATR.ARTICLE_TYPE,
      //   ],
      //   items: {
      //     [ATR.PRODUCT_VARIANTS]: {
      //       [ATR_CODE.PRODUCT_VARIANTS_CURRENT]: { ignore: '1' },
      //       [ATR_CODE.PRODUCT_VARIANTS_OUTLET]: { active: '1' },
      //       [ATR_CODE.ARCHIVE_ITEM]: { ignore: '1' },
      //     },
      //     [ATR.ARTICLE_TYPE]: {
      //       [ATR_CODE.BIKE]: { active: '1' },
      //       [ATR_CODE.SPAREPART]: { ignore: '1' },
      //     },
      //     [ATR.STOCK]: {
      //       [ATR_CODE.STOCK_SOLD_OUT]: { ignore: '1' },
      //     },
      //     [ATR.SEARCH_PRICE]: {
      //       [ATR_CODE.HIDDEN_MIN_VALUE_OFF]: '0.01',
      //     },
      //   },
      // },
      ACCESSORIES: {
        order: [ATR.ARTICLE_TYPE, ATR.ZZCA_CLIENT, ATR.PART_BRAND, ATR.CATEGORY, ATR.PIM_CATEGORY],
        openOnStart: [
          ATR.SUMMARY,
          ATR.PART_BRAND,
          ATR.BRAND_CATALOG,
          ATR.CATEGORY,
          ATR.PIM_CATEGORY,
          ATR.ZZCA_CLIENT,
        ],
        summaryOrder: [
          ATR.SEARCH_TEXT,
          ATR.ZZCA_CLIENT,
          ATR.PART_BRAND,
          ATR.CATEGORY,
          ATR.PIM_CATEGORY,
        ],
        summaryHideAndKeep: [
          ATR.SEARCH_INCLUDED,
          ATR.SEARCH_PAGE,
          ATR.SEARCH_OFFSET,
          ATR.SEARCH_LIMIT,
          ATR.ARTICLE_TYPE,
        ],
        summaryHideWhenOnlyOneOption: [ATR.PRODUCT_VARIANTS],
        items: {
          [ATR.PART_BRAND]: {
            [ATR_CODE.FOCUS]: { sort: 2 },
            [ATR_CODE.KALKHOFF]: { sort: 1 },
            [ATR_CODE.URBANARROW]: { sort: 3 },
            [ATR_CODE.GZ]: { ignore: '1', sort: 99 },
            [ATR_CODE.UO]: { ignore: '1', sort: 99 },
          },
          [ATR.ARTICLE_TYPE]: {
            [ATR_CODE.BIKE]: { ignore: '1' },
            [ATR_CODE.SPAREPART]: { ignore: '1' },
            [ATR_CODE.ACCESSORY]: { active: '1' },
          },
          [ATR.STOCK]: {
            [ATR_CODE.STOCK_SOLD_OUT]: { ignore: '1' },
          },
        },
      },
      ARCHIVE: {
        order: [
          ATR.ARTICLE_TYPE,
          // ATR.ITEM_SUPPLIER,

          ATR.ITEM_BRAND_ARCHIV,
          ATR.ITEM_BRAND,
          ATR.CATEGORIES,
          ATR.PRODUCT_SEASON,
          ATR.PRODUCT_BIDEX_COMMODITY_GROUP,
        ],
        openOnStart: [
          ATR.SUMMARY,
          ATR.ITEM_BRAND_ARCHIV,
          ATR.ITEM_BRAND,
          ATR.BRAND_CATALOG,
          ATR.PRODUCT_SEASON,
          ATR.PRODUCT_BIDEX_COMMODITY_GROUP,
          // ATR.ITEM_SUPPLIER,
        ],
        summaryOrder: [
          ATR.SEARCH_TEXT,
          ATR.SEARCH_PRICE,
          // ATR.ITEM_SUPPLIER,

          ATR.ITEM_BRAND_ARCHIV,
          ATR.CATEGORIES,
          ATR.PRODUCT_SEASON,
          ATR.PRODUCT_BIDEX_COMMODITY_GROUP,
        ],
        summaryHideAndKeep: [
          ATR.ITEM_SUPPLIER,
          ATR.PRODUCT_VARIANTS,
          ATR.SEARCH_INCLUDED,
          ATR.SEARCH_PAGE,
          ATR.SEARCH_OFFSET,
          ATR.SEARCH_LIMIT,
          ATR.ARTICLE_TYPE,
        ],
        items: {
          [ATR.ARTICLE_TYPE]: {
            [ATR_CODE.BIKE]: { active: '1' },
            [ATR_CODE.SPAREPART]: { ignore: '1' },
            [ATR_CODE.ACCESSORY]: { ignore: '1' },
          },
          [ATR.ITEM_BRAND]: {
            [ATR_CODE.SERVICE]: { ignore: '1' },
            [ATR_CODE.DC_CERVELO]: { ignore: '1' },
            // eslint-disable-next-line spaced-comment
///////////////////////////////////////////
            [ATR_CODE.UA_FAMILY_SEGMENTS]: { ignore: '1' },
            [ATR_CODE.UA_CARGO_BIKE]: { ignore: '1' },
            [ATR_CODE.UA_WALK_FAMILY_BIKE]: { ignore: '1' },
            [ATR_CODE.UA_WALK_CARGO_BIKE]: { ignore: '1' },
            // eslint-disable-next-line spaced-comment
//////////////////////
          },
          [ATR.ITEM_BRAND_ARCHIV]: {
            [ATR_CODE.SERVICE]: { ignore: '1' },
            [ATR_CODE.DC_CERVELO]: { ignore: '1' },
          },
          [ATR.PRODUCT_VARIANTS]: {
            [ATR_CODE.PRODUCT_VARIANTS_CURRENT]: { active: '1' },
            [ATR_CODE.PRODUCT_VARIANTS_OUTLET]: { active: '1' },
            [ATR_CODE.ARCHIVE_ITEM]: { active: '1' },
          },
          [ATR.PRODUCT_SEASON]: {
            EARLY: { ignore: '1' },
            // 2024: { ignore: '1' },
            2026: { ignore: '1' },
          },
          // [ATR.ITEM_SUPPLIER]: {
          //   '004751': { show: '1', active: '1' },
          //   Derby: { show: '1', active: '1' },
          // },
        },
      },
    },
    items: {
      [ATR.ITEM_BRAND]: {
        [ATR_CODE.UNIVEGA]: { ignore: '1' },
        [ATR_CODE.SERVICE]: { ignore: '1' },
        // eslint-disable-next-line spaced-comment
///////////////////////////////////////
        [ATR_CODE.UA_FAMILY_SEGMENTS]: { ignore: '1' },
        [ATR_CODE.UA_CARGO_BIKE]: { ignore: '1' },
        [ATR_CODE.UA_WALK_FAMILY_BIKE]: { ignore: '1' },
        [ATR_CODE.UA_WALK_CARGO_BIKE]: { ignore: '1' },
        // eslint-disable-next-line spaced-comment
//////////////////
      },
      [ATR.PRODUCT_MAIN_CATEGORY]: {
        [ATR_CODE.PARTS]: { ignore: '1' },
      },
      [ATR.ITEM_FILTER_COLOR]: {
        WHT: { bgColor: '#fff', textColor: '#000' },
        RED: { bgColor: '#d46b68', textColor: '#000' },
        BLK: { bgColor: '#2f2f2f', textColor: '#fff' },
        GRY: { bgColor: '#b4c1c8', textColor: '#000' },
        GRE: { bgColor: '#a5cb7f', textColor: '#000' },
        SIL: { bgColor: '#e1e9ee', textColor: '#000' },
        BLU: { bgColor: '#a6d2e4', textColor: '#000' },
        BRW: { bgColor: '#be9a6f', textColor: '#000' },
        BEI: { bgColor: '#e1dbc7', textColor: '#000' },
        YEL: { bgColor: '#f6f399', textColor: '#000' },
        ORA: { bgColor: '#edc072', textColor: '#000' },
        PUR: { bgColor: '#800080', textColor: '#fff' },
        White: { bgColor: '#fff', textColor: '#000' },
        Red: { bgColor: '#d46b68', textColor: '#000' },
        Black: { bgColor: '#2f2f2f', textColor: '#fff' },
        Grey: { bgColor: '#b4c1c8', textColor: '#000' },
        Green: { bgColor: '#a5cb7f', textColor: '#000' },
        Silver: { bgColor: '#e1e9ee', textColor: '#000' },
        Blue: { bgColor: '#a6d2e4', textColor: '#000' },
        Brown: { bgColor: '#be9a6f', textColor: '#000' },
        Yellow: { bgColor: '#f6f399', textColor: '#000' },
        Orange: { bgColor: '#edc072', textColor: '#000' },
        Purple: { bgColor: '#800080', textColor: '#fff' },
        Gold: { bgColor: '#b69037', textColor: '#fff' },
      },
      FOR_COMBINED_ITEM_FRAME_SIZE_ItemFrameSizeCode: {
        XXXXS: { ignore: '0', sizesCmMin: '10', sizesCmMax: '19' },
        XXXS: { ignore: '0', sizesCmMin: '20', sizesCmMax: '32' },
        XXS: { ignore: '0', sizesCmMin: '30', sizesCmMax: '38' },
        XS: { ignore: '0', sizesCmMin: '38', sizesCmMax: '43' },
        S: { ignore: '0', sizesCmMin: '42', sizesCmMax: '47' },
        M: { ignore: '0', sizesCmMin: '46', sizesCmMax: '52' },
        L: { ignore: '0', sizesCmMin: '52', sizesCmMax: '56' },
        X: { ignore: '1', sizesCmMin: '0', sizesCmMax: '0' },
        XL: { ignore: '0', sizesCmMin: '55', sizesCmMax: '62' },
        XXL: { ignore: '0', sizesCmMin: '60', sizesCmMax: '64' },
        XXXL: { ignore: '0', sizesCmMin: '63', sizesCmMax: '80' },
        ONESIZE: { ignore: '1', sizesCmMin: '1', sizesCmMax: '100' },
      },
      [ATR.ITEM_FRAME_SIZE]: {
        XXXXS: { ignore: '0', sortIndex: '1' },
        XXXS: { ignore: '0', sortIndex: '2' },
        XXS: { ignore: '0', sortIndex: '3' },
        XS: { ignore: '0', sortIndex: '4' },
        S: { ignore: '0', sortIndex: '5' },
        M: { ignore: '0', sortIndex: '6' },
        L: { ignore: '0', sortIndex: '7' },
        X: { ignore: '1', sortIndex: '8' },
        XL: { ignore: '0', sortIndex: '9' },
        XXL: { ignore: '0', sortIndex: '10' },
        XXXL: { ignore: '0', sortIndex: '11' },
        ONESIZE: { ignore: '1', sortIndex: '12' },
      },
      'ItemGenderFrame_NO-GROUPS': {
        groups: {
          1: { items: 'DI,HE', icon: 'DI' },
          2: { items: 'DA,DT,LA,TR', icon: 'TR' },
          3: { items: 'DC', icon: '' },
          4: { items: 'CO,WA', icon: 'CO' },
          5: { items: 'MI', icon: '' },
          6: { items: 'CL,TS', icon: '' },
          7: { items: 'CP,UX', icon: '' },
        },
      },
      [ATR.PRODUCT_BIDEX_COMMODITY_GROUP]: {
        101010: { group: 'xx1010' },
        101020: { group: 'xx1020' },
        101030: { group: 'xx1030' },
        101040: { group: 'xx1040' },
        101050: { group: 'xx1050' },
        102010: { group: 'xx2010' },
        102020: { group: 'xx2020' },
        103010: { group: 'xx3010' },
        103020: { group: 'xx3020' },
        103030: { group: 'xx3030' },
        103040: { group: 'xx3040' },
        103050: { group: 'xx3050' },
        103060: { group: 'xx3060' },
        104010: { group: 'xx4010' },
        104020: { group: 'xx4020' },
        104030: { group: 'xx4030' },
        104040: { group: 'xx4040' },
        109010: { group: 'xx9010' },
        109020: { group: 'xx9020' },
        109030: { group: 'xx9030' },
        109040: { group: 'xx9040' },
        109050: { group: 'xx9050' },
        109090: { group: 'xx9090' },
        121010: { group: 'xx1010' },
        121020: { group: 'xx1020' },
        121030: { group: 'xx1030' },
        121050: { group: 'xx1050' },
        122010: { group: 'xx2010' },
        122020: { group: 'xx2020' },
        123010: { group: 'xx3010' },
        123020: { group: 'xx3020' },
        123030: { group: 'xx3030' },
        123040: { group: 'xx3040' },
        123050: { group: 'xx3050' },
        124010: { group: 'xx4010' },
        124040: { group: 'xx4020' },
        129010: { group: 'xx9010' },
        129020: { group: 'xx9020' },
        129030: { group: 'xx9030' },
        129040: { group: 'xx9040' },
        129050: { group: 'xx9050' },
        129090: { group: 'xx9090' },
        131010: { group: 'xx1010' },
        131020: { group: 'xx1020' },
        131030: { group: 'xx1030' },
        131040: { group: 'xx1040' },
        132010: { group: 'xx2010' },
        132020: { group: 'xx2020' },
        133010: { group: 'xx3010' },
        133020: { group: 'xx3020' },
        133030: { group: 'xx3030' },
        133040: { group: 'xx3040' },
        133050: { group: 'xx3050' },
        133060: { group: 'xx3060' },
        134010: { group: 'xx4010' },
        134040: { group: 'xx4040' },
        139010: { group: 'xx9010' },
        139020: { group: 'xx9020' },
        139030: { group: 'xx9030' },
        139040: { group: 'xx9040' },
        139090: { group: 'xx9090' },
        // Excludes from BE AppConfig
        309090: { ignore: 1 },
        202310: { ignore: 1 },
        205010: { ignore: 1 },
        207060: { ignore: 1 },
        553030: { ignore: 1 },
        205070: { ignore: 1 },
        207040: { ignore: 1 },
        201020: { ignore: 1 },
        301540: { ignore: 1 },
        309010: { ignore: 1 },
        202030: { ignore: 1 },
        206090: { ignore: 1 },
        206020: { ignore: 1 },
        202190: { ignore: 1 },
        205090: { ignore: 1 },
        202050: { ignore: 1 },
        203090: { ignore: 1 },
        207090: { ignore: 1 },
        208040: { ignore: 1 },
        202090: { ignore: 1 },
        301790: { ignore: 1 },
        207030: { ignore: 1 },
        208020: { ignore: 1 },
        205060: { ignore: 1 },
        202040: { ignore: 1 },
        301460: { ignore: 1 },
        301410: { ignore: 1 },
        208010: { ignore: 1 },
        209090: { ignore: 1 },
        204090: { ignore: 1 },
        205020: { ignore: 1 },
        208090: { ignore: 1 },
        201050: { ignore: 1 },
        208050: { ignore: 1 },
        208030: { ignore: 1 },
        202060: { ignore: 1 },
        202210: { ignore: 1 },
        202290: { ignore: 1 },
        201030: { ignore: 1 },
        201090: { ignore: 1 },
        202220: { ignore: 1 },
        202020: { ignore: 1 },
        202230: { ignore: 1 },
        // End Excludes from BE AppConfig
      },
    },
  },
  items: {
    [ATR.ITEM_BRAND]: {
      brand: {
        [ATR_CODE.RALEIGH]: 'raleigh',
        [ATR_CODE.FOCUS]: 'focus',
        [ATR_CODE.KALKHOFF]: 'kalkhoff',
        [ATR_CODE.URBANARROW]: 'urbanarrow',
        // uaFamilySegments: 'uaFamilySegments',
        [ATR_CODE.UNIVEGA]: 'univega',
        [ATR_CODE.DC_CERVELO]: 'DCCervelo',
        [ATR_CODE.DCSANTACRUZ]: 'DCSANTACRUZ',
        [ATR_CODE.DCJULIANA]: 'DCJULIANA',
        [ATR_CODE.GZ]: 'gz',
        [ATR_CODE.UO]: 'uo',
      },
      sort: {
        [ATR_CODE.RALEIGH]: '3',
        [ATR_CODE.FOCUS]: '2',
        [ATR_CODE.URBANARROW]: '3',
        [ATR_CODE.KALKHOFF]: '1',
        [ATR_CODE.UNIVEGA]: '6',
        [ATR_CODE.DC_CERVELO]: '4',
        [ATR_CODE.DCSANTACRUZ]: '5',
        [ATR_CODE.DCJULIANA]: '7',
        [ATR_CODE.SERVICE]: '8',
      },
    },
  },
}
